/**
 * 用户api
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();
export function addUser(params) {
	/**add 子用户 */
	return api.post('/api/user_sub_v3', params)
}

export function getUserTree() {
	/**查询当前用户子用户tree */
	return api.get('/api/user_sub_tree_v3',)
}
export function deleteUserV3(id) {
	/**删除子用户 */
	return api.delete(`/api/user_sub_v3/${id}`)
}

export function putUserV3(id, params) {
	/**删除子用户 */
	return api.put(`/api/user_sub_v3/${id}`, params)
}